import { HistoryOutlined } from '@ant-design/icons';
import { ProductSupplierPurchaseOrderDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, Modal, Table, Typography } from 'antd';
import { useState } from 'react';
import { formatDate } from 'src/utils/date-util';

interface AgCellTransactionHistoryProps extends ICellRendererParams {
  value: string | null; // messageBodyEditedAt
  data: ProductSupplierPurchaseOrderDoc;
}

export const AgCellTransactionHistory = (params: AgCellTransactionHistoryProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { value, data } = params;

  // 수정 이력이 없는 경우 일반 텍스트로 표시
  if (!value || !data.transactionHistory || data.transactionHistory.length === 0) {
    return value ? formatDate(value, 'yyyy-MM-dd HH:mm:ss') : '';
  }

  const columns = [
    {
      title: '수정일시',
      dataIndex: 'modifiedAt',
      key: 'modifiedAt',
      render: (text: string) => formatDate(text, 'yyyy-MM-dd HH:mm:ss'),
    },
    {
      title: '변경전 내용',
      dataIndex: 'snapshot',
      key: 'snapshot',
      render: (snapshot: string) => (
        <div style={{ maxHeight: '300px', overflow: 'auto', whiteSpace: 'pre-wrap' }}>{snapshot}</div>
      ),
    },
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button type='link' onClick={showModal} style={{ padding: 0 }} icon={<HistoryOutlined />}>
        {formatDate(value, 'yyyy-MM-dd HH:mm:ss')}
      </Button>

      <Modal
        title='발주서 수정 이력'
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800}
        styles={{
          body: {
            maxHeight: 'calc(100vh - 200px)',
            overflow: 'auto',
            paddingRight: 8,
          },
        }}>
        <Typography.Title level={5} style={{ marginTop: 16 }}>
          현재 메시지:
        </Typography.Title>
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: 16 }}>
          {data.messageBody}
        </Typography.Paragraph>
        <Table
          dataSource={data.transactionHistory
            .sort((a, b) => new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime())
            .map((item, index) => ({
              ...item,
              key: index,
            }))}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      </Modal>
    </>
  );
};
